(function () {
  const copy = {
    it: { button: 'Preordina', trust: '<strong>Preordine: spedizione dalla disponibilità indicata</strong> · Pagamenti sicuri · Assistenza Shopponi' },
    en: { button: 'Pre-order', trust: '<strong>Pre-order: ships from the indicated availability date</strong> · Secure payments · Shopponi support' },
    fr: { button: 'Précommander', trust: '<strong>Précommande : expédition à partir de la date de disponibilité indiquée</strong> · Paiements sécurisés · Assistance Shopponi' },
    de: { button: 'Vorbestellen', trust: '<strong>Vorbestellung: Versand ab dem angegebenen Verfügbarkeitsdatum</strong> · Sichere Zahlungen · Shopponi-Support' },
    es: { button: 'Reservar', trust: '<strong>Reserva: envío a partir de la fecha de disponibilidad indicada</strong> · Pagos seguros · Asistencia Shopponi' }
  };

  const locale = (document.documentElement.lang || 'it').toLowerCase().split('-')[0];
  const text = copy[locale] || copy.it;
  const preorderPattern = /(preordine|pre-order|preorder|précommande|vorbestell|reserva)/i;

  function setText(el, value) {
    if (el && el.textContent.trim() !== value) el.textContent = value;
  }

  function updatePreorderCards(root) {
    (root || document).querySelectorAll('.product-card-wrapper').forEach((card) => {
      const isPreorder = Array.from(card.querySelectorAll('.custom-badge, .badge')).some((badge) =>
        preorderPattern.test((badge.textContent || '').trim())
      );
      if (!isPreorder) return;

      const directButton = card.querySelector('.card--block-button .add-to-cart-button:not([disabled])');
      if (!directButton) return;

      setText(directButton.querySelector('.quick-add__label'), text.button);
      directButton.querySelectorAll('.text-inner').forEach((label) => setText(label, text.button));
    });
  }

  function applyProductPreorderUi() {
    if (document.body.dataset.shopponiPreorder !== 'true') return;

    document.querySelectorAll('.buy-buttons-block .product-form__submit .add-to-cart-text__content').forEach((label) => setText(label, text.button));
    document.querySelectorAll('sticky-atc .product-form__submit .add-to-cart-text').forEach((label) => setText(label, text.button));

    const trust = document.querySelector('.shopponi-product-trust-wrap p, .shopponi-product-trust p');
    if (trust && trust.innerHTML !== text.trust) trust.innerHTML = text.trust;
  }

  async function detectProductPreorder() {
    const productInfo = document.querySelector('product-info[data-url]');
    if (!productInfo || !document.body.classList.contains('template-product')) return;

    try {
      const url = new URL(productInfo.dataset.url, window.location.origin);
      url.pathname = url.pathname.replace(/\/$/, '') + '.js';
      const response = await fetch(url.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!response.ok) return;
      const product = await response.json();
      const rawTags = Array.isArray(product.tags) ? product.tags : String(product.tags || '').split(',');
      const isPreorder = rawTags.some((tag) => /pre[- ]?ordine|pre[- ]?order/i.test(String(tag).trim()));
      if (!isPreorder) return;

      document.body.dataset.shopponiPreorder = 'true';
      applyProductPreorderUi();

      const main = document.getElementById('MainContent');
      if (main) {
        const observer = new MutationObserver(applyProductPreorderUi);
        observer.observe(main, { childList: true, subtree: true });
      }
    } catch (error) {
      // Keep the native theme behaviour if the product JSON endpoint is unavailable.
    }
  }

  function init() {
    updatePreorderCards(document);
    detectProductPreorder();

    const grid = document.getElementById('ProductGridContainer');
    if (grid) {
      const gridObserver = new MutationObserver(() => updatePreorderCards(grid));
      gridObserver.observe(grid, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
